<template>
  <div>
    <!-- 订单详情页非活动邀请好友 -->
    <template v-if="shareType == 1 && posterEnable && !payShare">
      <div id="double_canvas">
        <div id="J_share_poster" class="share-container" ref="canvasRef" v-if="orderCommodity && imageInfos">
          <div class="share-inner">
            <div class="share-logo">
              <img
                data-width="138"
                data-height="37"
                data-src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTM4IiBoZWlnaHQ9IjM3IiB2aWV3Qm94PSIwIDAgMTM4IDM3IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xMjQuNTc0IDMwLjUyM0gxMTIuODFjLTYuNjEzIDAtNy4yLTUuNDIyLTcuMi03LjA3OXMuNTg3LTcuMDc5IDcuMi03LjA3OWgxMS43NjRjNi42MTMgMCA3LjIwMiA1LjQyMiA3LjIwMiA3LjA4IDAgMS42NTYtLjU4OSA3LjA3OC03LjIwMiA3LjA3OG0wLTIwLjEyMUgxMTIuODFjLTEyLjIyNiAwLTEzLjMxMyA5Ljk5LTEzLjMxMyAxMy4wNDIgMCAzLjA1MiAxLjA4NyAxMy4wNDMgMTMuMzEzIDEzLjA0M2gxMS43NjRjMTIuMjI2IDAgMTMuMzEzLTkuOTkgMTMuMzEzLTEzLjA0MyAwLTMuMDUyLTEuMDg3LTEzLjA0Mi0xMy4zMTMtMTMuMDQybS0yNy40MzcuNjExaC0zLjgxM2MtMS42MzQgMC0xLjk3LjI4LTIuNiAxLjIxMy0uNjMuOTM1LTExLjUzNiAxNy41ODItMTEuNTM2IDE3LjU4Mi0uMzQ4LjUxMi0uNzE2LjcyLTEuMTc2LjcyLS40NTkgMC0uODI4LS4yMDgtMS4xNzYtLjcyIDAgMC0xMC45MDUtMTYuNjQ3LTExLjUzNi0xNy41ODItLjYzLS45MzQtLjk2Ni0xLjIxMy0yLjU5OS0xLjIxM2gtMy44MTNjLS44NzggMC0xLjI3OS42ODYtLjcyNyAxLjUyNGwxMy4wMjUgMTkuNzc1YzIuMDIyIDIuOTczIDMuNTA1IDQuMTc1IDYuODI2IDQuMTc1IDMuMzIyIDAgNC44MDUtMS4yMDIgNi44MjYtNC4xNzVsMTMuMDI2LTE5Ljc3NWMuNTUyLS44MzguMTUtMS41MjQtLjcyNy0xLjUyNG0tNTAuNjQyIDEuNjE2YzAtMS4xNTcuNDU5LTEuNjE1IDEuNjE1LTEuNjE1aDIuODgyYzEuMTU3IDAgMS42MTYuNDU4IDEuNjE2IDEuNjE1VjM0Ljg3YzAgMS4xNTctLjQ2IDEuNjE2LTEuNjE2IDEuNjE2SDQ4LjExYy0xLjE1NiAwLTEuNjE1LS40NTktMS42MTUtMS42MTZWMTIuNjN6bS0uMjYzLTYuODA4Yy0uOTQtLjkzOS0uOTQtMS42ODMgMC0yLjYyM2wyLjAwOC0yLjAwN2MuOTM5LS45MzkgMS42ODQtLjkzOSAyLjYyMyAwbDIuMDA4IDIuMDA3Yy45MzguOTQuOTM4IDEuNjg0IDAgMi42MjNsLTIuMDA4IDIuMDA3Yy0uOTQuOTQtMS42ODQuOTQtMi42MjMgMGwtMi4wMDgtMi4wMDd6bS02LjAxOCA1LjE5MmgtMy44MTNjLTEuNjMyIDAtMS45Ny4yOC0yLjU5OSAxLjIxMy0uNjMuOTM1LTExLjUzNiAxNy41ODItMTEuNTM2IDE3LjU4Mi0uMzQ4LjUxMi0uNzE3LjcyLTEuMTc2LjcyLS40NiAwLS44MjgtLjIwOC0xLjE3Ni0uNzIgMCAwLTEwLjkwNi0xNi42NDctMTEuNTM2LTE3LjU4Mi0uNjMtLjkzNC0uOTY2LTEuMjEzLTIuNi0xLjIxM0gxLjk2N2MtLjk4IDAtMS4yOC42ODYtLjcyNyAxLjUyNGwxMy4wMjUgMTkuNzc1YzIuMDIxIDIuOTczIDMuNTA1IDQuMTc1IDYuODI2IDQuMTc1IDMuMzIxIDAgNC44MDUtMS4yMDIgNi44MjYtNC4xNzVsMTMuMDI2LTE5Ljc3NWMuNTUxLS44MzguMjUzLTEuNTI0LS43MjgtMS41MjQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="
              />
            </div>
            <div class="share-img">
              <img :data-width="commodityImgSize" :data-height="commodityImgSize" :data-src="commodityImgUrl" />
            </div>
            <div class="share-detail">
              <p class="share-name">{{ orderCommodity.commodityName }}</p>
              <p class="share-description" v-if="shareMsg">{{ shareMsg.shortBrief }}</p>
              <p class="share-price-panel">
                <span class="share-price-label">¥</span>
                <span class="share-price-1">{{ orderCommodity.salePrice }}</span>
              </p>
            </div>
            <div class="share-qrcode-panel">
              <div class="qrcode-des">
                <p class="line-1">长按二维码查看产品详情</p>
                <p class="line-2">分享来自vivo官方商城</p>
              </div>
              <!-- <img :src="shareMsg.qrcodeUrl" class="qrcode"  v-if="shareMsg"/> -->
            </div>
          </div>
          <p class="share-quanyi" v-if="guaranteeList">
            <span>{{ guaranteeList }}</span>
          </p>
        </div>
        <div id="J_mini_poster" :class="{ top9: !isProxySale }" class="mini-container" v-if="env.isVivoApp">
          <div class="mini-img">
            <img :data-width="commodityImgSize" :data-height="commodityImgSize" :data-src="commodityImgUrl" />
          </div>
          <p class="mini-quanyi" v-if="guaranteeShort">
            <span>{{ guaranteeShort }}</span>
          </p>
        </div>
      </div>
    </template>
    <!-- 支付结果页v码购分享 -->
    <template v-if="shareType == 1 && posterEnable && payShare">
      <div id="double_canvas">
        <div id="J_share_poster" class="share-container pay-share" ref="canvasRef">
          <div class="share-inner">
            <img class="bg" :src="orderCommodity.sharePicUrl" alt="">
          </div>
          <div class="share-img-vcode">
            <img :data-width="commodityImgPaySize" :data-height="commodityImgPaySize" :data-src="orderCommodity.commodityImgUrl" />
          </div>
          <div class="share-detail pay">
            <p class="share-name">{{ productName[0] }}</p>
            <p class="share-description">{{ productName[1] }}</p>
          </div>
        </div>
      </div>
    </template>
    <!-- 拼团&一分团邀请好友主链路 -->
    <!-- 推荐活动页(改为原生canvas绘制) -->
    <!-- <template v-if="shareType == 2">
      <div id="double_canvas">
        <div id="J_share_poster" class="share-container" ref="canvasRef" v-if="activityShareMsg">
          <img data-width="840" data-height="1345" class="activity-poster" :data-src="activityShareMsg.posterImg" />
          <img data-width="430" data-height="430" :data-src="activityShareMsg.qrcodeUrl" class="activity-qrcode" />
        </div>
      </div>
    </template> -->
    <!-- 分享海报 -->
    <v-os-popup
      class="share-popup"
      :show="posterShow"
      :title="isShareAward ? '推荐有礼' : '分享'"
      fullScreen
      @close="posterShow = false"
      :footerShow="false"
      container="body"
    >
      <template>
        <a
          class="gift-tip"
          v-if="this.shareType == 1 && showGiftTip"
          :href="shareAwardMsg.shareLinkUrl"
          v-track="{
            act: 'click',
            params: {
              cfrom: '00220|077',
              event_id: '00220|077',
              sku_id: orderCommodity.commoditySkuId,
              share_type: 2,
              clickPos: 2,
              page_type: 3
            }
          }"
        >
          <span v-html="textContent"></span>
          <v-button type="frame" size="small" lineColor="#52391c">查看规则</v-button>
        </a>
        <div class="gift-tip" v-if="this.shareType == 2 && showGiftTip">
          <span v-html="textContent"></span>
        </div>
        <div class="poster-img">
          <img :src="frontPoster" alt v-if="frontPoster" />
          <v-list-loading class="loading-container" v-else></v-list-loading>
        </div>
        <div class="save-tip" v-if="frontPoster">
          <template v-if="env.isBankabc || env.isVHome || env.isVivoHealth || env.isvChat">截图保存图片</template>
          <template v-else>长按图片可保存</template>
        </div>
      </template>
    </v-os-popup>
    <!-- H5推荐活动分享兜底 -->
    <nx-dialog className="clipboard-dialog" v-model="clipboardShow" title="复制链接转发" :btns="dialogButtons">
      <div class="clipboard-info" v-if="activityShareMsg">
        {{ activityShareMsg.shortUrl || activityShareMsg.h5Url }}
      </div>
    </nx-dialog>
  </div>
</template>
<script>
import env from '@/utils/clientEnv'
import create from '../create'
import { app } from '@/utils'
import { asyncLoadJs } from '@/utils/dom'
import config from '@/config'
import { getPosterInfo, queryPosterCmdDetail, sharePosterWx, getActivityShareMsg } from './api'

export default create({
  name: 'painter',
  props: {
    shareType: {
      type: Number,
      default: 1 // 1:订单详情页非活动邀请好友 2:推荐活动页 3:拼团邀请好友主链路 4:一分团邀请好友主链路
    },
    isShareAward: {
      type: Boolean,
      default: false
    },
    orderCommodity: {
      type: Object
    },
    shareOptions: {
      type: Object
    },
    payShare: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      payShareType: '',
      shareAwardMsg: null, // 普通分享推荐有礼配置信息
      shareMsg: null, // 普通分享海报图信息
      activityShareMsg: {}, // 推荐有礼活动页分享所有信息汇总
      posterShow: false, // H5分享个海报图弹层展示
      clipboardShow: false, // 推荐活动粘贴弹层展示
      frontPoster: null, // 海报图
      miniPoster: null, // 小程序海报图
      bgCanvasBase64: '',
      commodityServiceTips: null, // 保障信息
      imageInfos: null, // 商品图片信息
      spuInfo: null, // spu相关信息
      skuInfo: null, // sku相关信息
      env,
      dialogButtons: [
        {
          text: '复制',
          handler: () => {
            this.handleClipboard()
          }
        },
        {
          text: '取消',
          handler: () => {
            this.clipboardShow = false
          },
          type: 'link'
        }
      ]
    }
  },
  computed: {
    productName() {
      const strArr = this.orderCommodity.commodityDesc.split(/(\s+\d+G[a-zA-Z]*\s*\+?\s*\d*[G|T][a-zA-Z]*.)/)
      const str1 = strArr[0].trim()
      let arr2 = strArr.slice(1)
      // 判断sku版本之后紧跟着一个（,而且规格_颜色字符串内存在中文括号时，增加新的名称规则逻辑。
      if (arr2[0] && arr2[0].indexOf('（') === arr2[0].length - 1) {
        if (arr2.join('').split(/(（.*）)/).length > 1) {
          arr2 = this.orderCommodity.commodityDesc.split(/(\s+\d+G[a-zA-Z]*\s*\+?\s*\d*[G|T][a-zA-Z]（.*）)/).slice(1)
        }
      }
      const str2 = arr2
        .filter(v => v.trim())
        .map(v => v.trim())
        .join(' | ')
      return [str1, str2]
    },
    /**
     * 是否为代销商品
     */
    isProxySale() {
      return this.spuInfo?.proxySale == 1 || false
    },
    posterEnable() {
      // 根据渠道判断 IOS客户端 或者 Andorid6及以下
      if (env.isIOSVivoApp || env.androidLevel <= 6) {
        return false
      }
      // 根据APP支持版本号判断
      if (env.isVivoApp && env.appVersion < 6750) {
        return false
      }
      return true
    },
    isProd() {
      return process.env.NODE_ENV === 'production'
    },
    commodityImgSize() {
      const matchList = this.commodityImgUrl.match(/_(\d{0,4})x/i)
      if (matchList && matchList.length > 1) {
        return matchList[1] - 0
      }
      return 750
    },
    commodityImgPaySize() {
      const matchList = this.orderCommodity.commodityImgUrl.match(/_(\d{0,4})x/i)
      if (matchList && matchList.length > 1) {
        return matchList[1] - 0
      }
      return 750
    },
    commodityImgUrl() {
      return this.imageInfos?.[0]?.bigPic + '?t='+new Date().getTime()
    },
    hasServiceTip() {
      return (this.commodityServiceTips || []).length > 0
    },
    guaranteeList() {
      const MAX_LEN = 21 // 容纳的字符上限
      let tips = (this.commodityServiceTips || []).flatMap(v => v.serviceName)
      if (!tips.length) return ''
      // 仅取前4个权益
      if (tips.length > 4) {
        tips = tips.splice(0, 4)
      }
      const originStr = tips.join('')
      if (originStr.length > MAX_LEN) {
        const lastStr = originStr.slice(MAX_LEN)
        let index = tips.findIndex(tip => {
          return !!lastStr.match(new RegExp(tip))
        })

        if (index < 0) {
          tips = tips.length > 1 ? tips.splice(0, tips.length - 1) : [tips[0]]
        } else {
          tips = tips[index] == lastStr || index <= 1 ? tips.splice(0, index) : tips.splice(0, index - 1)
        }
      }
      return tips.join(' · ')
    },
    guaranteeShort() {
      const MAX_LEN = 18 // 容纳的字符上限
      let tips = (this.commodityServiceTips || []).flatMap(v => v.serviceName)
      if (!tips.length) return ''
      // 仅取前4个权益
      if (tips.length > 3) {
        tips = tips.splice(0, 3)
      }
      const originStr = tips.join('')
      if (originStr.length > MAX_LEN) {
        const lastStr = originStr.slice(MAX_LEN)
        let index = tips.findIndex(tip => {
          return !!lastStr.match(new RegExp(tip))
        })

        if (index < 0) {
          tips = tips.length > 1 ? tips.splice(0, tips.length - 1) : [tips[0]]
        } else {
          tips = tips[index] == lastStr || index <= 1 ? tips.splice(0, index) : tips.splice(0, index - 1)
        }
      }
      return tips.join(' · ')
    },
    textContent() {
      const text =
        this.shareType == 1
          ? this.shareAwardMsg?.textContent
          : this.shareType == 2
          ? this.activityShareMsg?.textContent
          : ''
      if (env.isOS4) {
        return text?.replace(/(\d+)/g, `<span style="font-weight: 400;">$1</span>`)
      } else {
        return text?.replace(/(\d+)/g, `<span style="-webkit-text-stroke: 0.3px;">$1</span>`)
      }
    },
    shareFunctionMap() {
      return {
        1: 'orderShareConfig',
        2: 'activityShareConfig'
      }
    },
    canvasDisableMap() {
      return {
        1: 'setDefaultPoster',
        2: 'showActivityClipboard'
      }
    },
    showGiftTip() {
      if (this.shareType == 1 && this.isShareAward && this.textContent) return true
      if (this.shareType == 2 && this.textContent) return true
      return false
    }
  },

  methods: {
    updateShareConfig() {
      const funcName = this.shareFunctionMap[this.shareType]
      const shareParams = this[funcName]()
      // app分享
      if (this.shareType == 2 && env.isWx) {
        // 微信H5推荐活动-分享仅分享当前页
        return
      }
      if(this.payShare) {
        let params = {
          shareChannel: '8',
          base64Pic: encodeURIComponent(shareParams.posterLargeImg),
          posterUrl: `share-poster-${Date.now()}.png`,
          isWithForumChannelNewStyle: true,
          vivoSpaceShareType: 'pay_order'
        }
        if(this.payShareType == 1) {
          setTimeout(()=>{
            this.doCommodityShare(2)
          },2500)
        } else {
          if(shareParams.posterLargeImg) {
            window.WeiwoJSBridge.call('showShare', params)
          }
        }
      }else {
       app.setShareConfig(shareParams)
      }
    },
    handleCanvasDisable() {
      const funcName = this.canvasDisableMap[this.shareType]
      this[funcName]()
    },
    queryPromise(params) {
      return new Promise((resolve, reject) => {
        queryPosterCmdDetail(params)
          .then(res => {
            const {
              commodityServiceTips,
              shareInfo,
              commoditySpu,
              commoditySkuBaseInfo,
              imageInfos,
              postCommodityDto
            } = res
            this.commodityServiceTips = commodityServiceTips
            this.shareAwardMsg = shareInfo
            this.shareMsg = postCommodityDto
            this.imageInfos = imageInfos
            this.spuInfo = commoditySpu
            this.skuInfo = commoditySkuBaseInfo
            resolve(res)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async initBgPainter() {
      // 请求分享的商品信息，并生成背景图
      if(this.payShare) {
        this.initHtmlCanvas()
      } else {
        await this.queryPromise(this.shareOptions)
        this.initHtmlCanvas()
      }
    },
    /**
     * 初始化生成海报图背景 - 仅在前端支持生成海报图的前提下处理
     *
     */
    initHtmlCanvas() {
      // 延迟支持
      if (this.posterEnable && !this.bgCanvasBase64) {
        if (env.isVivoApp) {
          // 客户端内
          return this.hasServiceTip ? this.posterDoublePromise() : this.posterSimplePromise()
        } else {
          // H5
          return this.posterSimplePromise()
        }
      }
      return new Promise(resolve => {
        resolve()
      })
    },
    queryQrcodePromise() {
      return new Promise((resolve, reject) => {
        // 改为请求二维码接口 耗时600ms
        const time1 = new Date().getTime()
        sharePosterWx(this.shareOptions)
          .then(res => {
            console.log('请求接口耗时')
            console.log(new Date().getTime() - time1)
            const qrcode = `data:image/png;base64,${res}`
            const image = new Image()
            image.setAttribute('crossOrigin', 'anonymous')
            image.src = qrcode
            image.onload = function () {
              console.log('图片拉取耗时')
              console.log(new Date().getTime() - time1)
              resolve(image)
            }
            image.onerror = function () {
              reject('小程序码获取失败1')
            }
          })
          .catch(e => {
            reject('小程序码获取失败2')
          })
      })
    },
    /**
     * 叠加请求获取二维码，合并模版canvas和二维码图片
     * 前提是背景海报 & 二维码都加载完成才可以执行合并操作
     */
    async compositionCanvas() {
      const self = this
      const t0 = new Date().getTime()
      console.log(t0)
      let qrcode = null
      try {
        const res = this.payShare ? this.initHtmlCanvas() : await Promise.all([this.queryQrcodePromise(), this.initHtmlCanvas()])
        qrcode = res[0] || null
      } catch (e) {
        this.handleCanvasDisable()
        return
      }
      const image = new Image()
      image.src = this.bgCanvasBase64
      const imgPromise = new Promise(resolve => {
        image.onload = function () {
          console.log('bgCanvasBase64 load')
          console.log(new Date().getTime() - t0)
          resolve()
        }
      })
      imgPromise
        .then(res => {
          const canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height

          var ctx = canvas.getContext('2d')

          ctx.drawImage(image, 0, 0)
          if(!this.payShare) {
            ctx.drawImage(qrcode, 789, 1368, 221, 221)
          }

          // 将canvas对象转换为base64位编码
          self.frontPoster = canvas.toDataURL('image/jpeg', 1)
          console.log('最终耗时')
          console.log(new Date().getTime() - t0)
          console.log(new Date().getTime())
          self.updateShareConfig()
        })
        .catch(e => {
          self.handleCanvasDisable()
        })
    },
    /**
     * 生成大海报图和小程序海报图
     */
    async posterDoublePromise() {
      return new Promise((resolve, reject) => {
        if (this.bgCanvasBase64) resolve()
        const canvasContent = document.querySelector('#double_canvas')
        const shareContent = document.querySelector('#J_share_poster')
        const miniContent = document.querySelector('#J_mini_poster')
        var width = canvasContent.offsetWidth
        var scale = 1080 / width
        html2canvas(
          canvasContent,
          {
            useCORS: true, // 【重要】开启跨域配置
            removeContainer: this.isProd,
            scale: scale,
            width: shareContent?.offsetWidth,
            height: shareContent?.offsetHeight,
            selector: 'share-container',
            logging: !this.isProd,
            ignoreElements: child => {
              const position = child.compareDocumentPosition(canvasContent)
              if (position >= 8 || position >= 16 || position == 0) {
                return false
              }
              if (child.tagName == 'HEAD' || (child.tagName === 'STYLE' && child.hasAttribute('data-canvas-ignore'))) {
                return false
              }
              return true
            },
            allowTaint: true // 允许跨域图片
          },
          {
            useCORS: true, // 【重要】开启跨域配置
            removeContainer: this.isProd,
            scale: scale,
            logging: !this.isProd,
            width: miniContent.offsetWidth,
            height: miniContent.offsetHeight,
            selector: 'mini-container',
            ignoreElements: child => {
              const position = child.compareDocumentPosition(canvasContent)
              if (position >= 8 || position >= 16 || position == 0) {
                return false
              }
              if (child.tagName == 'HEAD' || (child.tagName === 'STYLE' && child.hasAttribute('data-canvas-ignore'))) {
                return false
              }
              return true
            },
            allowTaint: true // 允许跨域图片
          }
        )
          .then(canvasList => {
            const canvas0 = canvasList[0]
            const canvas1 = canvasList[1]
            this.bgCanvasBase64 = canvas0.toDataURL('image/jpeg', 1)
            if (canvas1) {
              this.miniPoster = canvas1.toDataURL('image/jpeg', 1)
            }
            resolve()
          })
          .catch(e => {
            reject(e)
            console.log(e)
          })
      })
    },
    /**
     * 单独生成海报图
     */
    async posterSimplePromise() {
      return new Promise((resolve, reject) => {
        if (this.bgCanvasBase64) resolve()
        const shareContent = document.querySelector('#J_share_poster')
        var width = shareContent.offsetWidth
        var height = shareContent.offsetHeight
        var scale = 1080 / width
        html2canvas(shareContent, {
          useCORS: true, // 【重要】开启跨域配置
          removeContainer: this.isProd,
          scale: scale,
          width: width,
          height: height,
          logging: !this.isProd,
          ignoreElements: child => {
            const position = child.compareDocumentPosition(shareContent)
            if (position >= 8 || position >= 16 || position == 0) {
              return false
            }
            if (child.tagName == 'HEAD' || (child.tagName === 'STYLE' && child.hasAttribute('data-canvas-ignore'))) {
              return false
            }
            return true
          },
          allowTaint: true // 允许跨域图片
        })
          .then(canvas => {
            const path = (this.bgCanvasBase64 = canvas.toDataURL('image/jpeg', 1))
            this.miniPoster = this.miniPoster || this.commodityImgUrl
            resolve(path)
          })
          .catch(e => {
            reject(e)
            console.log(e)
          })
      })
    },
    /**
     * 针对订单详情页无预设数据的普通分享 - 点击生成海报图
     */
    doCommodityShare(type) {
      this.payShareType = type
      console.log(new Date().getTime())
      if (!this.posterEnable) {
        this.$emit('error')
        return
      }
      this.showPoster()
      // 支持前端生成海报图
      if (env.isVivoApp) {
        // 客户端内
        if (!this.frontPoster) {
          if (this.bgCanvasBase64) {
            this.compositionCanvas()
            return
          }
          // 延迟避免iframe与webveiw启动冲突
          setTimeout(() => {
            this.compositionCanvas()
          }, 100)
        }
        return
      } else {
        // H5
        if (!this.frontPoster) {
          this.compositionCanvas()
        }
        return
      }
    },

    async showPoster() {
      if (env.isVivoApp) {
        this.updateShareConfig()
        setTimeout(() => {
          if(!this.payShare) {
            app.doShare()
          }
        }, 20)
      } else if (!this.posterShow) {
        this.posterShow = true
      }
    },

    setShareMsgShow(shareMsg) {
      this.activityShareMsg = { ...this.activityShareMsg, ...shareMsg }
      this.showPoster()
      this.generatePoster()
    },
    getImagePromise() {
      const image = new Image()
      image.setAttribute('crossOrigin', 'anonymous')
      image.src = this.activityShareMsg.posterImg
      return new Promise((resolve, reject) => {
        image.onload = function () {
          console.log('posterImg load')
          resolve(image)
        }
        image.onerror = function () {
          console.log('posterImg error')
          reject()
        }
      })
    },

    getShareMsgPromise() {
      //  点击生成后调用接口 - 接口分享
      return new Promise((resolve, reject) => {
        getActivityShareMsg().then(res => {
          this.activityShareMsg = {
            ...this.activityShareMsg,
            ...{
              h5Url: res.h5Url, // '异步请求 跳转长链接 - 避免短链服务不可用
              shortUrl: res.shortUrl, //异步请求 跳转短链
              miniAppUrl: res.miniAppUrl, //异步请求 小程序path
              qrcodeUrl: res.qrcodeUrl
            }
          }
          const qrcode = `data:image/png;base64,${res.qrcodeUrl}`
          const image = new Image()
          image.setAttribute('crossOrigin', 'anonymous')
          image.src = qrcode
          image.onload = function () {
            console.log('图片拉取耗时')
            resolve(image)
          }
          image.onerror = function () {
            reject('小程序码获取失败1')
          }
        })
      })
    },
    generatePoster() {
      const self = this
      if (this.frontPoster) return
      Promise.all([this.getImagePromise(), this.getShareMsgPromise()])
        .then(res => {
          // 同时获取poster背景图 & 二维码
          const bgImg = res[0]
          const qrcode = res[1]
          const canvas = document.createElement('canvas')
          canvas.width = 1080
          canvas.height = 1729
          var ctx = canvas.getContext('2d')
          ctx.drawImage(bgImg, 0, 0, 1080, 1729)
          ctx.drawImage(qrcode, 789, 1368, 221, 221)
          // 将canvas对象转换为base64位编码
          self.frontPoster = canvas.toDataURL('image/jpeg', 1)
          self.updateShareConfig()
        })
        .catch(e => {
          console.log(e)
          self.handleCanvasDisable()
        })
    },

    /**
     * 订单详情-推荐好友 分享设置参数
     */
    orderShareConfig() {
      const images = this.imageInfos
      const miniImg = ((images || [])[0] || {}).bigPic || ''

      let shareParams = {
        title: this.isShareAward
          ? `向你推荐【${this.orderCommodity.commodityName}】`
          : `${this.orderCommodity.commodityName}`,
        desc: this.skuInfo?.brief,
        link:
          this.shareMsg?.shortUrl ||
          `${config.path.shopUrl}/product/${this.orderCommodity.commoditySpuId}?skuId=${this.orderCommodity.commoditySkuId}&isNoShare=1`,
        miniPath: this.shareMsg?.miniAppUrl
          ? `pages/product/index?${this.shareMsg.miniAppUrl}`
          : `pages/product/index?spuId=${this.orderCommodity.commoditySpuId}&skuId=${this.orderCommodity.commoditySkuId}&isNoShare=1`,
        images: images,
        sharePosterToSpaceFlag: -1, // 设置分享朋友圈为海报大图分享
        downloadChannelShow: -1, // 控制保存图片按钮是否展示
        weiboChannelShow: -1, // -1不展示微博分享渠道, 0展示微博分享渠道
        posterLargeImg: this.frontPoster || '', // 海报图&小程序封面图配置
        shareFrom: 'order'
      }
      let title = shareParams.title
      // 推荐有礼（原分享赚-已登录状态下）
      if (this.isShareAward) {
        shareParams = {
          ...shareParams,
          ...{
            title: title + '立即查看>',
            wxfriend: {
              title: title.replace(/\+/gi, ' + '),
              miniImg: this.miniPoster || miniImg,
              miniPath: shareParams.miniPath
            },
            copy: {
              title: title + '立即查看'
            }
          }
        }
        // 分享弹层上方&折叠屏pad利益条相关配置
        shareParams.dialogAdvImg = this.shareAwardMsg?.shareIcon
        shareParams.dialogAdvImgJump = shareParams.dialogCustomContentJump = this.shareAwardMsg?.shareLinkUrl
        shareParams.dialogCustomTitle = this.shareAwardMsg?.shareTitle
        shareParams.dialogCustomContent = this.shareAwardMsg?.textContent
        shareParams.dialogAdvIcon = this.shareAwardMsg?.actPic // 悬浮活动图片
        shareParams.dialogAdvTextColor = this.shareAwardMsg?.textColor // 文案颜色
        shareParams.dialogAdvBg = this.shareAwardMsg?.benefitColor // 利益条底色
      } else {
        // 普通分享
        shareParams = {
          ...shareParams,
          ...{
            title: `【${title}】立即查看>`,
            wxfriend: {
              title: title.replace(/\+/gi, ' + '),
              miniImg: this.miniPoster || miniImg,
              miniPath: shareParams.miniPath
            },
            copy: {
              title: `【${title}】立即查看`
            }
          }
        }
      }
      return shareParams
    },
    /**
     * 推荐有礼-活动分享 设置参数
     */
    activityShareConfig() {
      const shareParams = {
        title: '推荐你来vivo商城购物，最高领100元优惠券>',
        desc: '手机、配件福利券限量抢',
        link: this.activityShareMsg.shortUrl || this.activityShareMsg.h5Url,
        images: [{ bigPic: this.activityShareMsg.miniProgramImg, smallPic: this.activityShareMsg.qqLinkImg }],
        sharePosterToSpaceFlag: this.posterEnable ? -1 : 0, // 设置分享朋友圈为海报大图分享
        downloadChannelShow: this.posterEnable ? -1 : 0, // 控制保存图片按钮是否展示
        weiboChannelShow: this.posterEnable ? -1 : 0, // -1不展示微博分享渠道, 0展示微博分享渠道
        posterLargeImg: this.frontPoster || '', // 海报图&小程序封面图配置
        wxfriend: {
          title: '向你推荐一些好物',
          miniImg: this.activityShareMsg.miniProgramImg,
          miniPath: `pages/h5/index?${this.activityShareMsg.miniAppUrl}`
        },
        copy: {
          title: `推荐你来vivo商城购物，最高领100元优惠券`
        },
        shareFrom: 'recommend'
      }
      // 分享弹层上方&折叠屏pad利益条相关配置
      shareParams.dialogAdvImg = this.activityShareMsg?.shareIcon // 客户端旧版本利益条图片
      shareParams.dialogCustomTitle = this.activityShareMsg?.shareTitle
      shareParams.dialogCustomContent = this.activityShareMsg?.textContent
      shareParams.dialogAdvImgJump = shareParams.dialogCustomContentJump=  '' // 活动页是最终页，不支持再跳转
      shareParams.dialogAdvIcon = '' // 活动页是最终页，不支持再跳转
      shareParams.dialogAdvTextColor = this.activityShareMsg?.textColor // 文案颜色
      shareParams.dialogAdvBg = this.activityShareMsg?.benefitColor // 利益条底色
      return shareParams
    },

    /**
     * 设置生成海报图失败的降级逻辑，走原服务端接口能力，或直接用商品主图
     */
    setDefaultPoster() {
      let params = {
        spuId: this.orderCommodity.commoditySpuId,
        skuId: this.orderCommodity.commoditySkuId,
        // 1：普通分享 2：分享赚分享
        channel: this.isShareAward ? 2 : 1,
        isNoShare: 1,
        promotionId: ''
      }
      // 合约机增加buyType入参
      if (this.shareOptions.buyType == 3) {
        params.buyType == 3
      }
      getPosterInfo(params)
        .then(data => {
          this.frontPoster = this.frontPoster || data.commodityPosterUrl
          this.miniPoster = this.miniPoster || this.commodityImgUrl
          this.updateShareConfig()
        })
        .catch(e => {
          this.frontPoster = this.frontPoster || this.commodityImgUrl
          this.miniPoster = this.miniPoster || this.commodityImgUrl
          this.updateShareConfig()
        })
    },
    /**
     * 设置推荐有礼不适配 & 海报图生成异常场景下的降级逻辑
     */
    showActivityClipboard() {
      // APP高版本生成海报图异常 - 分享弹层已经展示，按照产品意见，默认loading不做降级
      // 非APP内收起弹层，提示复制链接
      if (!env.isVivoApp) {
        this.posterShow = false
        this.clipboardShow = true
      }
    },
    handleClipboard() {
      app.copyContent(this.activityShareMsg.shortUrl || this.activityShareMsg.h5Url, () => {
        this.$toast('复制成功')
      })
    },
    shareClose() {
      this.posterShow = false
    }
  },
  async mounted() {
    if (!this.posterEnable || this.shareType == 2) return
    await asyncLoadJs(`${config.path.shopFrontBaseUrl}static/lib/html2canvas974.min.js`)
    var style = document.createElement('style')
    style.type = 'text/css'
    style.dataset['canvasIgnore'] = 'false'
    let styleInner = `#double_canvas {
  font-family: 'Microsoft Yahei', Arial;
  font-variant: normal;
  position: fixed;
  width: 8.4rem;
  height: 14rem;
  z-index: -999;
  top: -999px;
  left: -999px;
  background: #FFFFFF;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
#double_canvas .share-container {
  font-family: 'Microsoft Yahei', Arial;
  font-variant: normal;
  position: relative;
  width: 8.4rem;
  z-index: -999;
  background: #FFFFFF;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
#double_canvas .share-container * {
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
#double_canvas .share-container p{
  quotes: none;
}
#double_canvas .share-container img{
  max-width: 100%;
  vertical-align: bottom;
}`
    //     if (this.shareType == 2) {
    //       styleInner += `
    // .share-container {
    //   height: 13.45rem;
    // }
    // .activity-poster{
    //   position: absolute;
    //   width: 8.4rem;
    //   height: 13.45rem;
    //   left: 0;
    //   top: 0;
    //   font-size:0;
    //   object-fit: contain;
    // }
    // .activity-qrcode{
    //   position: absolute;
    //   width: 1.72rem;
    //   height: 1.72rem;
    //   right: 0.55rem;
    //   bottom: 1.09rem;
    //   font-size:0;
    //   object-fit: contain;
    // }
    // `
    //     } else {
    styleInner += `
#double_canvas .share-container .share-inner{
  position: relative;
  width: 8.4rem;
  height: 12.75rem;
  background: #FFFFFF;
}
#double_canvas .pay-share .share-inner {
  background: #000000;
}
#double_canvas .share-container .share-inner .bg{
  width: 8.4rem;
  height: 12.75rem;
}
#double_canvas .share-logo {
  position: absolute;
  width: 2.08rem;
  height: 0.55rem;
  left: 3.16rem;
  top: 0.78rem;
  font-size:0;
}
#double_canvas .share-logo img{
  width: 2.08rem;
  height: 0.55rem;
}
#double_canvas .share-img {
  position: absolute;
  width: 6.06rem;
  height: 6.06rem;
  left: 1.17rem;
  top: 2.1rem;
}
#double_canvas .share-img img{
  width: 6.06rem;
  height: 6.06rem;
  object-fit: contain;
}
#double_canvas .share-img-vcode {
  position: absolute;
  width: 6rem;
  height: 6rem;
  left: 1.2rem;
  top: 3.3rem;
}
#double_canvas .share-img-vcode img{
  width: 6rem;
  height: 6rem;
  object-fit: contain;
}
#double_canvas .share-detail {
  position: absolute;
  bottom: 2.92rem;
  width: 100%;
  text-align: center;
}
#double_canvas .pay {
  position: absolute;
  bottom: 2.34rem;
  width: 100%;
  text-align: center;
}
#double_canvas .share-name {
  width: 5.92rem;
  margin: 0 auto;
  color: #000000;
  font-size: 0.36rem;
  line-height: 0.42rem;
  font-weight: 500;
}
#double_canvas .pay .share-name {
  width: 5.92rem;
  margin: 0 auto;
  color: #ffffff;
  font-size: 0.42rem;
  line-height: 0.42rem;
  font-weight: 500;
}
#double_canvas .pay .share-description {
  padding-top: 0.26rem;
  color: #666;
  font-size: 0.30rem;
  line-height: 0.39rem;
}
#double_canvas .share-description {
  padding-top: 0.15rem;
  color: #333;
  font-size: 0.36rem;
  line-height: 0.36rem;
}
#double_canvas .share-price-panel {
  vertical-align: bottom;
  height: 0.36rem;
  font-size: 0;
  margin-top: 0.24rem;
  color: #000000;
}
#double_canvas .share-price-label {
  display: inline-block;
  font-size: 0.3rem;
  line-height: 0.3rem;
  margin-right: 0.04rem;
  font-weight: 400;
}
#double_canvas .share-price-1 {
  display: inline-block;
  font-size: 0.36rem;
  line-height: 0.36rem;
  font-weight: 500;
}
#double_canvas .share-quanyi {
  position: relative;
  background: #1B1A1A;
  text-align: center;
  height: 0.7rem;
  padding: 0.2rem 0;
  color: rgba(255, 255, 255, 0.44);
  white-space:nowrap;
  box-sizing: border-box;
}
#double_canvas .share-quanyi span{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%) scale(0.5);
    font-size: 0.6rem;
    line-height: 0.6rem;
    display: inline-block;
}
#double_canvas .share-qrcode-panel {
  position: absolute;
  bottom:  0;
  left: 0;
  width: 100%;
  height: 2.32rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
          justify-content: space-between;
  background: #F5F5F5;
  padding: 0.21rem 0.55rem 0.39rem 0.65rem;
  box-sizing: border-box;
}

#double_canvas .share-qrcode-panel .qrcode {
  width: 1.72rem;
  height: 1.72rem;
}
#double_canvas .share-qrcode-panel .line-1 {
  padding-top: 0.54rem;
  color: rgba(153, 153, 153, 0.71);;
  font-size: 0.3rem;
  line-height: 0.3rem;
}
#double_canvas .share-qrcode-panel .line-2 {
  color: rgba(153, 153, 153, 0.71);;
  font-size: 0.3rem;
  line-height: 0.3rem;
  margin-top: 0.18rem;
}
.vivo-fontscale-1 #double_canvas .share-name{
  font-size: 0.45rem;
  line-height: 0.525rem;
}
.vivo-fontscale-2 #double_canvas .share-name{
  font-size: 0.4rem;
  line-height: 0.47rem;
}
.vivo-fontscale-4 #double_canvas .share-name{
  font-size: 0.32rem;
  line-height: 0.375rem;
}
.vivo-fontscale-5 #double_canvas .share-name{
    font-size: 0.288rem;
  line-height:  0.336rem;
}
.vivo-fontscale-1 #double_canvas .share-description ,
.vivo-fontscale-1 #double_canvas .share-price-1{
  font-size: 0.45rem;
  line-height: 0.45rem;
}
.vivo-fontscale-2 #double_canvas .share-description,
.vivo-fontscale-2 #double_canvas .share-price-1{
  font-size: 0.4rem;
  line-height: 0.4rem;
}
.vivo-fontscale-4 #double_canvas .share-description,
.vivo-fontscale-4 #double_canvas .share-price-1{
  font-size: 0.32rem;
  line-height: 0.32rem;
}
.vivo-fontscale-5 #double_canvas .share-description,
.vivo-fontscale-5 #double_canvas .share-price-1{
    font-size: 0.288rem;
  line-height:  0.288rem;
}
.vivo-fontscale-1 #double_canvas .share-quanyi span{
      font-size: 0.75rem;
  line-height: 0.75rem;
}
.vivo-fontscale-2 #double_canvas .share-quanyi span{
      font-size: 0.66rem;
  line-height: 0.66rem;
}
.vivo-fontscale-4 #double_canvas .share-quanyi span{
    font-size: 0.54rem;
  line-height:  0.54rem;
}
.vivo-fontscale-5 #double_canvas .share-quanyi span{
    font-size: 0.48rem;
  line-height:  0.48rem;
}
.vivo-fontscale-1 #double_canvas .share-price-label,
.vivo-fontscale-1 #double_canvas .share-qrcode-panel .line-1,
.vivo-fontscale-1 #double_canvas .share-qrcode-panel .line-2{
      font-size: 0.375rem;
  line-height: 0.375rem;
}
.vivo-fontscale-2 #double_canvas .share-price-label,
.vivo-fontscale-2 #double_canvas .share-qrcode-panel .line-1,
.vivo-fontscale-2 #double_canvas .share-qrcode-panel .line-2{
      font-size: 0.33rem;
  line-height: 0.33rem;
}
.vivo-fontscale-4 #double_canvas .share-price-label,
.vivo-fontscale-4 #double_canvas .share-qrcode-panel .line-1,
.vivo-fontscale-4 #double_canvas .share-qrcode-panel .line-2{
    font-size: 0.27rem;
  line-height:  0.27rem;
}
.vivo-fontscale-5 #double_canvas .share-price-label,
.vivo-fontscale-5 #double_canvas .share-qrcode-panel .line-1,
.vivo-fontscale-5 #double_canvas .share-qrcode-panel .line-2{
    font-size: 0.24rem;
  line-height:  0.24rem;
}
.vivo-fontscale-1 #double_canvas .share-price-label{
  vertical-align: top;
  margin-top: 0.03rem;
}
.vivo-fontscale-4 #double_canvas .share-price-label{
  vertical-align: top;
  margin-top: 0.04rem;
}
.vivo-fontscale-5 #double_canvas .share-price-label{
  vertical-align: top;
  margin-top: 0.06rem;
}
`
    if (env.isVivoApp) {
      styleInner += `
    #double_canvas .mini-container * {
      margin: 0;
      padding: 0;
      border: 0;
      font: inherit;
      font-size: 100%;
      vertical-align: baseline;
    }
    #double_canvas .mini-container p {
      quotes: none;
    }
    #double_canvas .mini-container img {
      max-width: 100%;
      vertical-align: bottom;
    }
    #double_canvas .mini-container {
      font-family: 'Microsoft Yahei', Arial;
      font-variant: normal;
      position: fixed;
      top: -99999;
      left: -99999;
      width: 6rem;
      height: 4.8rem;
      z-index: -999;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      background: transparent;
    }
    #double_canvas .mini-img {
      position: relative;
      width: 4.35rem;
      height: 4.35rem;
      margin: 0 auto;
      text-align: center;
    }
    #double_canvas .mini-container.top9  .mini-img{
      margin-top: -0.09rem;
    }
    #double_canvas .mini-img img{
      width: 4.35rem;
      height: 4.35rem;
      object-fit: contain;
    }
    #double_canvas .mini-quanyi {
      position:relative;
      text-align: center;
      height: 0.3rem;
      margin-top: 0.08rem;
      color: #999999;
      white-space:nowrap;
    }
    #double_canvas .mini-container.top9  .mini-quanyi{
       margin-top: 0.17rem;
    }
    #double_canvas .mini-quanyi span{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        font-size: 0.3rem;
        line-height: 0.3rem;
        display: inline-block;
        white-space:nowrap;
    }
    .vivo-fontscale-1 #double_canvas .mini-quanyi span{
        line-height: 0.375rem;
      font-size: 0.375rem;
    }
    .vivo-fontscale-2 #double_canvas .mini-quanyi span{
            line-height: 0.335rem;
      font-size: 0.335rem;
    }
    .vivo-fontscale-4 #double_canvas .mini-quanyi span{
        font-size: 0.27rem;
      line-height:  0.27rem;
    }
    .vivo-fontscale-5 #double_canvas .mini-quanyi span{
        font-size: 0.24rem;
      line-height:  0.24rem;
    }
    `
    }
    // }

    style.innerHTML = styleInner
    document.getElementsByTagName('head').item(0).appendChild(style)
    setTimeout(() => {
      // if (this.shareType == 1) {
      this.initBgPainter()
      // }
    }, 0)
  },
  watch: {
    posterShow(val) {
      const params = {
        event_id: '00219|077',
        channel: 'post',
        sku_id: this.shareType == 1 ? this.orderCommodity.commoditySkuId : '',
        share_type: this.showGiftTip ? 2 : 1,
        popup_type: 2,
        page_type: this.shareType == 1 ? 3 : 2 // 3订单详情 2推荐活动 4支付成功页面
      }
      if(this.payShare) {
        params.page_type = 4
      }
      this.$track(params)
    },
    'orderCommodity.commoditySkuId'() {
      this.frontPoster = ''
      this.bgCanvasBase64 = ''
      this.miniPoster = ''
    }
  }
})
</script>
<style lang="scss" scoped>
.v-os-popup.share-popup {
  ::v-deep .container {
    .content {
      max-height: none;
    }
    .header {
      min-height: 150px;
      .tit-middle {
        line-height: 150px;
        font-size: 48px;
      }
      .close {
        top: 45px;
      }
    }
  }

  &.share-popup-bank {
    height: 80%;
  }
  .gift-tip {
    background: linear-gradient(90.74deg, #ffe4b9 3.92%, #ffedd1 97.11%);
    width: 100%;
    padding: 36px 48px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      color: #52391c;
      font-size: 42px;
      line-height: 48px;
    }
  }
  .title {
    text-align: center;
    color: $text-color-light;
    padding: 0 78px 65px;
    line-height: 1.4;
    font-size: 36px;
    display: block;
  }

  .poster-img {
    position: relative;
    padding-top: 28px;
    text-align: center;
    width: 840px;
    margin: 0 auto;
    img {
      width: 840px;
      max-height: calc(100vh - 440px);
      object-fit: contain;
      border: 0.5px solid #e0e0e0;
    }
    .loading-container {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      margin-top: 30vh;
      .text {
        width: 100%;
        font-size: 42px;
        line-height: 54px;
        color: #b2b2b2;
        white-space: nowrap;
        margin-top: 36px;
      }
    }
  }
  .save-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    font-size: 30px;
    line-height: 36px;
    color: #999999;
    &::before,
    &::after {
      content: '';
      display: inline-block;
      width: 173px;
      height: 2px;
      opacity: 0.2;
      margin: 0 21px;
      background: linear-gradient(270deg, #999999 0%, rgba(153, 153, 153, 0) 122.25%);
    }
    &::after {
      transform: rotate(180deg);
    }
  }
}
.clipboard-info {
  margin: 72px auto 84px;
  width: 744px;
  font-size: 42px;
  line-height: 54px;
  letter-spacing: 0;
  color: #000;
  word-break: break-all;
  box-sizing: border-box;
}
</style>
